export const Alpha = ({ color = "black" }: { color?: "black" | "white" }) => {
  const getFillColor = () => {
    if (color === "black") return "fill-[#231F20]";
    if (color === "white") return "fill-[#fff]";
  };

  return (
    <svg
      className={getFillColor()}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 200 200"
    >
      <path
        d="M138.3,115.8c-2.1-5.5-5.3-10.2-9.3-14.2s-8.8-7.1-14.2-9.3S103.6,89,97.4,89c-6,0-11.8,1-17.1,3.1
	c-5.4,2.1-10.1,5.1-14.2,9.1c-4.1,4-7.3,8.7-9.5,14.2c-2.3,5.5-3.4,11.4-3.4,17.7s1.2,12.2,3.4,17.7S62,161,66.1,165
	c4.1,4,8.8,7,14.2,9.1c5.4,2.1,11.1,3.1,17.2,3.1c6.2,0,12-1.1,17.4-3.3c5.4-2.2,10.2-5.3,14.2-9.3c4-4.1,7.1-8.8,9.3-14.2
	c2.2-5.4,3.3-11.3,3.3-17.5S140.6,120.8,138.3,115.8z M116.7,166.4c-5.7,3.3-12.1,4.9-19.2,4.9s-13.5-1.6-19.1-4.9
	c-5.6-3.3-10-7.8-13.1-13.7c-3.1-5.9-4.7-12.5-4.7-19.9c0-7.3,1.5-13.8,4.6-19.7c3.1-5.8,7.4-10.4,13.1-13.7
	c5.7-3.3,12.1-4.9,19.2-4.9s13.5,1.6,19.2,4.9c3.4,1.9,6.2,4.3,8.7,7.1h-6.5l-3.8,13.4h-0.8c-1.9-5.1-4.2-8.8-6.8-11
	c-2.6-2.2-6.2-3.3-10.8-3.3c-6.2,0-11.4,2.6-15.8,7.7c-4.3,5.1-6.5,12-6.5,20.6c0,8.4,1.6,14.8,4.6,19.3s7.2,6.8,12.7,6.8
	c7.2,0,13.4-5.2,18.4-15.4h0.6c1.1,10.3,4.5,15.4,10.1,15.4c1.5,0,3-0.3,4.6-0.8C122.9,162,120.1,164.5,116.7,166.4z M109.8,132.7
	c-3.1,13.9-8.2,20.9-15.5,20.9c-6.7,0-10-6.8-10-20.3c0-7,1.2-12.7,3.5-16.9s5.4-6.3,9.3-6.3c3.6,0,6.4,1.7,8.3,5.1
	C107.4,118.6,108.8,124.5,109.8,132.7z M130.4,151.7L130.4,151.7c-2.1,1.6-3.9,2.4-5.4,2.4c-2.2,0-3.9-1.9-4.9-5.6
	c-1-3.7-1.9-9.3-2.7-16.7c4.3-10.7,7.7-18.1,10.3-22.3c0.8,1.1,1.5,2.3,2.2,3.6c3,5.9,4.6,12.5,4.6,19.8
	C134.5,139.8,133.1,146.1,130.4,151.7z"
      />
    </svg>
  );
};
